<template>
  <v-container grid-list-md >
    <Diccionario :id_unit="this.idUnidad" :isPractice="true"/>
    <div class="e-ejercicio">
      <div class="e-ejercicio-descripcion text-xs-left">
        <p class="instruccion mb-2" v-html="loadedLessons.instructions_spanish"></p>
      </div>
      <div class="e-ejercicio-ejercicio  pt-2">
        <v-layout  pt-0 column>
          <CardPregunta 
            :route="`/practica/intermedio/${idUnidad}/ejercicio/practicaDragLine`" 
            :pregunta="loadedLessons.exercise"
            :respuesta="loadedLessons.answer"/>
          <v-flex>
            <v-btn @click="texto" outline color="primary" round large class="my-3">
              <img src="../../../assets/images/practica/outline-text.svg" alt="Lectura" style="height: 20px;margin-top: 2px;margin-right: 5px;">
              VER EL TEXTO COMPLETO
            </v-btn>
            <CardTexto 
            :image="require('@/assets/images/unit/practice/' + loadedTextLessons.imagen)"
            :textKr="loadedTextLessons.large_text_korean"
            :textEs="loadedTextLessons.large_text_spanish"
            />
          </v-flex>
        </v-layout>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CardPregunta from '../../../components/Practica/intermedio/CardPregunta'
import CardTexto from '../../../components/Practica/Global/CardTexto'
import { storeFirebase } from '../../../store/firebase'

export default {
  name: 'practicaPregunta',
  props: ['idUnidad'],
  components: {
    CardPregunta,
    CardTexto
  },
  created () {
    this.loadLessons()
  },
  computed: {
    ...mapState({
      ui: state => state.ui
    }),
    loadedTextLessons () {
      const dataValues = storeFirebase.getters.loadedPracticeLessons
      const data = dataValues.filter(data => data.id_tipo_ejercicio == 9)
      return data[0]
    },
    loadedLessons () {
      const dataValues = storeFirebase.getters.loadedPracticeLessons
      const data = dataValues.filter(data => data.id_tipo_ejercicio == 10)
      return data[0]
    }
  },
  methods: {
    ...mapActions('ui', [
      'texto'
    ]),
    loadLessons () {
      const payload = {
        id_unit: Number(this.idUnidad),
        id_practice: 0
      }
      storeFirebase.dispatch("loadPracticeLessons", payload)
    }
  }
}
</script>
